export interface Film {
  id: string;
  title: string;
  originalTitle: string;
  year: number;
  releaseDate: string;
  genres: string[];
  region: string;
  duration: number;
  director: string;
  cast: string[];
  rating: number;
  views: number;
  tags: string[];
  quality: string;
  synopsis: string;
  cover: string;
  backdrop?: string;
}

export const films: Film[] = [
  {
    id: "yekou-lieche",
    title: "夜行列车",
    originalTitle: "夜行列車",
    year: 2024,
    releaseDate: "2024-09-12",
    genres: ["剧情", "悬疑"],
    region: "日本",
    duration: 128,
    director: "白石和弥",
    cast: ["松本莲", "佐野千寻", "高梨透"],
    rating: 8.7,
    views: 98640,
    tags: ["密室", "旅途", "人性"],
    quality: "4K 修复",
    synopsis:
      "一列开往北海道深处的末班夜行列车，在暴雪中被迫停靠无名小站。车厢里的七名乘客各自携带着无法言说的秘密，而随车乘务员在检票时发现了一张属于三十年前失踪者的旧车票。随着黎明临近，每个人都必须在谎言与真相之间做出选择。",
    cover:
      "https://readdy.ai/api/search-image?query=Cinematic%20Japanese%20mystery%20film%20poster%20artwork%2C%20a%20lone%20figure%20standing%20on%20a%20snowy%20night%20train%20platform%20lit%20by%20a%20single%20warm%20lamp%2C%20deep%20crimson%20and%20warm%20gray%20palette%2C%20soft%20film%20grain%2C%20elegant%20negative%20space%2C%20subtle%20paper%20texture%2C%20no%20text%2C%20moody%20editorial%20composition&width=600&height=900&seq=poster-yekou-lieche-2026&orientation=portrait",
    backdrop:
      "https://readdy.ai/api/search-image?query=Wide%20cinematic%20still%20of%20a%20snow%20covered%20train%20platform%20at%20night%20in%20northern%20Japan%2C%20warm%20amber%20lamps%20glowing%20against%20deep%20crimson%20dusk%20sky%2C%20falling%20snow%2C%20lone%20silhouette%20with%20a%20suitcase%2C%20muted%20moody%20tones%2C%20anamorphic%20film%20grain%2C%20no%20text&width=1600&height=900&seq=backdrop-yekou-lieche-2026&orientation=landscape",
  },
  {
    id: "baise-minato",
    title: "白色岬角",
    originalTitle: "白い岬",
    year: 2023,
    releaseDate: "2023-11-03",
    genres: ["剧情", "爱情"],
    region: "日本",
    duration: 116,
    director: "滨口纱枝",
    cast: ["宫泽葵", "中村悠真", "小林澄"],
    rating: 8.4,
    views: 87420,
    tags: ["海边", "离别", "夏天"],
    quality: "高清",
    synopsis:
      "在能登半岛尽头的小渔村，一名返鄉照顾父亲的摄影师遇见了守着灯塔的旧日同窗。两个曾经错身而过的人，用一个夏天重新整理了彼此的记忆，也终于说出了当年没能说出口的那句话。",
    cover:
      "https://readdy.ai/api/search-image?query=Poetic%20Japanese%20romantic%20drama%20poster%2C%20a%20white%20lighthouse%20on%20a%20rocky%20cape%20above%20a%20calm%20gray%20sea%2C%20distant%20woman%20in%20a%20linen%20dress%2C%20soft%20overcast%20light%2C%20muted%20warm%20neutral%20palette%20with%20a%20hint%20of%20crimson%2C%20delicate%20film%20grain%2C%20no%20text%2C%20quiet%20editorial%20composition&width=600&height=900&seq=poster-baise-minato-2026&orientation=portrait",
  },
  {
    id: "chenmo-de-dao",
    title: "沉默之刀",
    originalTitle: "沈黙の刃",
    year: 2022,
    releaseDate: "2022-06-18",
    genres: ["动作", "历史"],
    region: "日本",
    duration: 142,
    director: "黑木武",
    cast: ["大泽隆", "真木凉", "藤井源"],
    rating: 8.9,
    views: 132870,
    tags: ["武士", "复仇", "剑戟"],
    quality: "4K 修复",
    synopsis:
      "幕末京都，一名失去主家的浪人接下了替人复仇的委托，却在追查目标的过程中发现，自己不过是更大棋局里的一枚棋子。刀锋所向，是仇人，也是自己曾经坚守的信念。",
    cover:
      "https://readdy.ai/api/search-image?query=Restrained%20samurai%20period%20film%20poster%20artwork%2C%20silhouette%20of%20a%20ronin%20holding%20a%20katana%20in%20a%20bamboo%20grove%20at%20dusk%2C%20deep%20crimson%20and%20charcoal%20palette%2C%20ink%20wash%20texture%2C%20soft%20rain%20streaks%2C%20generous%20negative%20space%2C%20no%20text%2C%20high%20detail%20editorial%20composition&width=600&height=900&seq=poster-chenmo-de-dao-2026&orientation=portrait",
  },
  {
    id: "jingdu-siji",
    title: "京都四季",
    originalTitle: "京都の四季",
    year: 2021,
    releaseDate: "2021-04-09",
    genres: ["剧情", "家庭"],
    region: "日本",
    duration: 121,
    director: "河濑美智子",
    cast: ["树木希子", "山崎翔", "川岛铃"],
    rating: 8.5,
    views: 64510,
    tags: ["家庭", "京都", "治愈"],
    quality: "高清",
    synopsis:
      "一间位于京都西阵的老铺和果子店，四代人在一年四季的节令里守着同一口蒸笼。当最小的女儿决定离开，老店主开始用自己的方式，把那些无法言说的手艺与牵挂，慢慢交到她手里。",
    cover:
      "https://readdy.ai/api/search-image?query=Warm%20minimal%20Japanese%20family%20drama%20poster%2C%20traditional%20Kyoto%20machiya%20wooden%20facade%20with%20a%20small%20maple%20tree%20and%20paper%20lantern%2C%20soft%20seasonal%20afternoon%20light%2C%20cream%20and%20warm%20terracotta%20palette%2C%20fine%20paper%20grain%2C%20no%20text%2C%20serene%20balanced%20composition&width=600&height=900&seq=poster-jingdu-siji-2026&orientation=portrait",
  },
  {
    id: "yuzhong-de-yueding",
    title: "雨中的约定",
    originalTitle: "雨の約束",
    year: 2024,
    releaseDate: "2024-07-26",
    genres: ["爱情", "剧情"],
    region: "日本",
    duration: 108,
    director: "井上珊瑚",
    cast: ["森川遥", "岩田真", "佐伯绫"],
    rating: 8.1,
    views: 91230,
    tags: ["雨中", "重逢", "都市"],
    quality: "高清",
    synopsis:
      "十年前的一场暴雨里，两个高中生在废弃的公交站约定每年同一天见面。十年后的雨季，只剩下一个人还在等。直到某个傍晚，一把熟悉的透明雨伞停在了站牌下。",
    cover:
      "https://readdy.ai/api/search-image?query=Romantic%20Japanese%20film%20poster%20with%20a%20young%20couple%20sharing%20a%20clear%20umbrella%20on%20a%20rainy%20city%20street%20at%20blue%20hour%2C%20warm%20shop%20lights%20reflected%20in%20wet%20pavement%2C%20muted%20crimson%20accents%2C%20soft%20bokeh%2C%20film%20grain%2C%20no%20text%2C%20tender%20editorial%20composition&width=600&height=900&seq=poster-yuzhong-de-yueding-2026&orientation=portrait",
  },
  {
    id: "shenhai-huisheng",
    title: "深海回声",
    originalTitle: "深海のこだま",
    year: 2023,
    releaseDate: "2023-08-11",
    genres: ["悬疑", "惊悚"],
    region: "日本",
    duration: 133,
    director: "津田原野",
    cast: ["北村零", "松冈唯", "远藤光"],
    rating: 8.3,
    views: 76590,
    tags: ["海洋", "心理", "失踪"],
    quality: "高清",
    synopsis:
      "海洋声学研究员在分析一段来自日本海沟的异常录音时，听见了十年前失踪的姐姐的声音。她带着录音设备独自下潜，却在更深的地方，发现了一段被整个研究所刻意掩盖的往事。",
    cover:
      "https://readdy.ai/api/search-image?query=Atmospheric%20Japanese%20psychological%20thriller%20poster%2C%20a%20lone%20diver%20suspended%20in%20deep%20dark%20water%20with%20a%20single%20shaft%20of%20pale%20light%20from%20above%2C%20deep%20crimson%20and%20slate%20tones%2C%20fine%20suspended%20particles%2C%20subtle%20film%20grain%2C%20no%20text%2C%20cinematic%20vertical%20composition&width=600&height=900&seq=poster-shenhai-huisheng-2026&orientation=portrait",
  },
  {
    id: "yinghua-canying",
    title: "樱花残影",
    originalTitle: "桜の残像",
    year: 2020,
    releaseDate: "2020-03-27",
    genres: ["剧情", "经典"],
    region: "日本",
    duration: 137,
    director: "小津安次",
    cast: ["原节子", "笠智众", "田中绢代"],
    rating: 9.1,
    views: 152400,
    tags: ["经典", "昭和", "家族"],
    quality: "4K 修复",
    synopsis:
      "昭和末年的镰仓，一位老摄影师在妻子离世后，开始冲洗两人四十年来积攒的底片。照片里反复出现的那棵樱花树，牵出了一段他从未向儿女提起的往事。修复版以全新调色重现了胶片年代的柔光质感。",
    cover:
      "https://readdy.ai/api/search-image?query=Classic%20Showa%20era%20Japanese%20film%20poster%20in%20restored%20style%2C%20a%20blooming%20cherry%20tree%20beside%20an%20old%20wooden%20house%20in%20Kamakura%2C%20elderly%20figure%20seen%20from%20behind%2C%20faded%20rose%20and%20cream%20palette%2C%20visible%20analog%20grain%2C%20soft%20halation%2C%20no%20text%2C%20nostalgic%20editorial%20composition&width=600&height=900&seq=poster-yinghua-canying-2026&orientation=portrait",
    backdrop:
      "https://readdy.ai/api/search-image?query=Wide%20restored%20Showa%20era%20cinematic%20still%20of%20an%20old%20Kamakura%20wooden%20house%20garden%20with%20a%20large%20blooming%20cherry%20tree%2C%20petals%20drifting%20in%20warm%20late%20afternoon%20light%2C%20faded%20rose%20and%20cream%20palette%2C%20soft%20halation%2C%20gentle%20analog%20film%20grain%2C%20no%20text&width=1600&height=900&seq=backdrop-yinghua-canying-2026&orientation=landscape",
  },
  {
    id: "tiegui-jintou",
    title: "铁轨尽头",
    originalTitle: "線路の果て",
    year: 2022,
    releaseDate: "2022-10-14",
    genres: ["剧情", "公路"],
    region: "日本",
    duration: 112,
    director: "青山纪",
    cast: ["洼冢洋", "石桥静", "吉冈凑"],
    rating: 8.0,
    views: 42380,
    tags: ["公路", "旅途", "自我"],
    quality: "高清",
    synopsis:
      "一名刚被裁员的电气工程师，沿着一条即将废弃的地方铁路线徒步走到终点站。一路上他遇见了形形色色的乘客与站员，也重新拼凑起自己与父亲之间那段断裂的时间。",
    cover:
      "https://readdy.ai/api/search-image?query=Quiet%20Japanese%20road%20movie%20poster%2C%20single%20railway%20track%20receding%20through%20a%20rural%20valley%20with%20autumn%20grasses%20and%20distant%20mountains%2C%20lone%20traveler%20walking%20away%20from%20camera%2C%20warm%20dusty%20palette%20with%20crimson%20accent%2C%20soft%20evening%20light%2C%20film%20grain%2C%20no%20text&width=600&height=900&seq=poster-tiegui-jintou-2026&orientation=portrait",
  },
  {
    id: "dongri-huayuan",
    title: "冬日花园",
    originalTitle: "冬の庭",
    year: 2024,
    releaseDate: "2024-12-06",
    genres: ["爱情", "文艺"],
    region: "日本",
    duration: 105,
    director: "三浦杏",
    cast: ["二阶堂凛", "成田凌", "安藤樱"],
    rating: 8.2,
    views: 58120,
    tags: ["冬天", "植物", "慢节奏"],
    quality: "高清",
    synopsis:
      "植物園的温室管理员在冬季闭馆期间，遇见了一位每周三都会来画同一株植物的插画家。两个习惯了独处的人，用一整个冬天学习如何让别人走进自己的生活。",
    cover:
      "https://readdy.ai/api/search-image?query=Serene%20Japanese%20romantic%20art%20film%20poster%2C%20inside%20a%20glass%20greenhouse%20in%20winter%20with%20frosted%20panes%20and%20lush%20green%20plants%2C%20woman%20sketching%20at%20a%20wooden%20table%2C%20pale%20winter%20light%2C%20muted%20sage%20and%20terracotta%20palette%2C%20fine%20grain%2C%20no%20text%2C%20airy%20editorial%20composition&width=600&height=900&seq=poster-dongri-huayuan-2026&orientation=portrait",
  },
  {
    id: "heichao",
    title: "黑潮",
    originalTitle: "黒潮",
    year: 2021,
    releaseDate: "2021-09-17",
    genres: ["动作", "犯罪"],
    region: "日本",
    duration: 126,
    director: "深作欣",
    cast: ["役所广", "丰川悦", "池内博"],
    rating: 8.6,
    views: 113450,
    tags: ["黑帮", "港町", "复仇"],
    quality: "高清",
    synopsis:
      "横滨港的货运码头，一名前刑警以装卸工的身份潜伏进走私集团。当黑潮般的利益链条逐渐浮出水面，他发现自己要抓的人，正是当年把他踢出警队的那个人。",
    cover:
      "https://readdy.ai/api/search-image?query=Gritty%20Japanese%20crime%20thriller%20poster%2C%20silhouette%20of%20a%20man%20in%20a%20long%20coat%20at%20a%20container%20port%20at%20night%2C%20crimson%20harbor%20lights%20and%20diesel%20smoke%2C%20high%20contrast%20dark%20warm%20palette%2C%20heavy%20film%20grain%2C%20no%20text%2C%20gritty%20vertical%20composition&width=600&height=900&seq=poster-heichao-2026&orientation=portrait",
  },
  {
    id: "wusheng-de-zhengren",
    title: "无声的证人",
    originalTitle: "無言の証人",
    year: 2023,
    releaseDate: "2023-05-19",
    genres: ["悬疑", "犯罪"],
    region: "日本",
    duration: 118,
    director: "中江和",
    cast: ["阿部宽", "满岛光", "香川照"],
    rating: 8.8,
    views: 121780,
    tags: ["法庭", "推理", "真相"],
    quality: "高清",
    synopsis:
      "一起看似证据确凿的纵火案，唯一的目击者是一名从未开口说过话的少年。辩护律师在调查中逐渐意识到，沉默本身就是一份被精心设计过的证词。",
    cover:
      "https://readdy.ai/api/search-image?query=Minimal%20Japanese%20legal%20thriller%20poster%2C%20empty%20courtroom%20bench%20with%20a%20single%20window%20casting%20hard%20light%2C%20small%20figure%20of%20a%20teenager%20in%20the%20shadows%2C%20deep%20crimson%20and%20bone%20white%20palette%2C%20crisp%20graphic%20geometry%2C%20subtle%20grain%2C%20no%20text&width=600&height=900&seq=poster-wusheng-de-zhengren-2026&orientation=portrait",
  },
  {
    id: "xiari-jidian",
    title: "夏日祭典",
    originalTitle: "夏祭り",
    year: 2019,
    releaseDate: "2019-08-02",
    genres: ["青春", "爱情"],
    region: "日本",
    duration: 102,
    director: "矢口史",
    cast: ["桥本环", "菅田将", "永野芽"],
    rating: 7.9,
    views: 53760,
    tags: ["夏日", "青春", "烟花"],
    quality: "高清",
    synopsis:
      "小镇最后一年举办夏日祭典，五个即将各奔东西的高三学生决定在烟花升起之前，把藏在心里的话全部说出来。一个关于错过、告白与告别的夏天。",
    cover:
      "https://readdy.ai/api/search-image?query=Youthful%20Japanese%20summer%20film%20poster%2C%20group%20of%20teenagers%20in%20yukata%20walking%20along%20a%20lantern%20lit%20festival%20street%2C%20fireworks%20blooming%20above%20tiled%20rooftops%2C%20warm%20crimson%20and%20amber%20glow%2C%20soft%20bokeh%2C%20nostalgic%20film%20grain%2C%20no%20text&width=600&height=900&seq=poster-xiari-jidian-2026&orientation=portrait",
  },
  {
    id: "xueguo-laixin",
    title: "雪国来信",
    originalTitle: "雪国の手紙",
    year: 2020,
    releaseDate: "2020-12-11",
    genres: ["剧情", "爱情"],
    region: "日本",
    duration: 124,
    director: "新藤兼",
    cast: ["苍井优", "妻夫木聪", "风吹淳"],
    rating: 8.4,
    views: 71230,
    tags: ["雪国", "书信", "离别"],
    quality: "高清",
    synopsis:
      "新潟山间的小邮局里，一名邮差替一位老人送了三十年的信，收件人却始终是同一个已经不存在的地址。当他终于决定查清真相，才发现这些信寄给的是一个从未被说出口的约定。",
    cover:
      "https://readdy.ai/api/search-image?query=Snowy%20Japanese%20drama%20poster%2C%20small%20wooden%20post%20office%20in%20a%20deep%20snow%20village%20with%20warm%20window%20light%2C%20postman%20silhouette%20on%20a%20narrow%20path%2C%20muted%20blue%20gray%20and%20warm%20ochre%20palette%2C%20soft%20falling%20snow%2C%20film%20grain%2C%20no%20text&width=600&height=900&seq=poster-xueguo-laixin-2026&orientation=portrait",
  },
  {
    id: "dongjing-canxiang",
    title: "东京残响",
    originalTitle: "東京の残響",
    year: 2024,
    releaseDate: "2024-05-31",
    genres: ["悬疑", "剧情"],
    region: "日本",
    duration: 134,
    director: "石井裕",
    cast: ["妻夫木聪", "安藤樱", "松山研"],
    rating: 8.6,
    views: 104320,
    tags: ["都市", "声音", "记忆"],
    quality: "高清",
    synopsis:
      "东京某座高架桥下的录音棚里，一名声音设计师意外录下了一段十年前的地铁事故现场。为了找到声音的来源，他开始在城市的地下脉络中穿行，也一步步走近自己一直回避的那一天。",
    cover:
      "https://readdy.ai/api/search-image?query=Modern%20Japanese%20urban%20mystery%20poster%2C%20a%20recording%20studio%20window%20overlooking%20a%20neon%20lit%20Tokyo%20overpass%20at%20night%2C%20sound%20wave%20light%20trails%20in%20warm%20crimson%2C%20reflective%20wet%20street%2C%20moody%20high%20contrast%20composition%2C%20film%20grain%2C%20no%20text&width=600&height=900&seq=poster-dongjing-canxiang-2026&orientation=portrait",
    backdrop:
      "https://readdy.ai/api/search-image?query=Wide%20cinematic%20Tokyo%20night%20cityscape%20seen%20from%20a%20low%20overpass%2C%20traffic%20light%20streaks%20in%20warm%20amber%20and%20crimson%2C%20rain%20slicked%20asphalt%20reflections%2C%20distant%20tower%20silhouettes%2C%20moody%20atmospheric%20film%20grain%2C%20no%20text&width=1600&height=900&seq=backdrop-dongjing-canxiang-2026&orientation=landscape",
  },
  {
    id: "liulang-de-qishou",
    title: "流浪的棋手",
    originalTitle: "流浪の棋士",
    year: 2018,
    releaseDate: "2018-11-23",
    genres: ["剧情", "经典"],
    region: "日本",
    duration: 145,
    director: "山田洋",
    cast: ["绪形拳", "倍赏千惠", "渥美清"],
    rating: 9.0,
    views: 138900,
    tags: ["将棋", "人生", "昭和"],
    quality: "4K 修复",
    synopsis:
      "一名从未获得段位的街头棋手，在东京与乡间之间流浪了半生。他唯一留下的，是一本记满残局的笔记本，和一群被他改变过人生的对手。修复版重现了昭和街景的颗粒质感。",
    cover:
      "https://readdy.ai/api/search-image?query=Nostalgic%20Showa%20era%20Japanese%20film%20poster%2C%20elderly%20shogi%20player%20sitting%20at%20a%20worn%20wooden%20board%20under%20a%20paper%20lamp%20in%20a%20narrow%20alley%2C%20warm%20sepia%20and%20deep%20crimson%20palette%2C%20visible%20analog%20grain%2C%20soft%20halation%2C%20no%20text%2C%20quiet%20editorial%20composition&width=600&height=900&seq=poster-liulang-de-qishou-2026&orientation=portrait",
  },
  {
    id: "poxiao-zhiqian",
    title: "破晓之前",
    originalTitle: "夜明け前",
    year: 2022,
    releaseDate: "2022-02-25",
    genres: ["动作", "悬疑"],
    region: "日本",
    duration: 119,
    director: "坂本浩",
    cast: ["冈田准", "长泽雅", "松重丰"],
    rating: 8.2,
    views: 68410,
    tags: ["倒计时", "追捕", "都市"],
    quality: "高清",
    synopsis:
      "东京都心的地铁系统被植入了一枚定时装置，留给警视厅危机应对小组的时间只有六个小时。当所有人都在追踪嫌疑人时，组长却发现，真正的目标可能从来都不是那趟列车。",
    cover:
      "https://readdy.ai/api/search-image?query=Tense%20Japanese%20action%20thriller%20poster%2C%20empty%20subway%20platform%20with%20a%20single%20digital%20clock%20glowing%20red%2C%20long%20geometric%20perspective%20corridor%2C%20deep%20crimson%20and%20cool%20charcoal%20palette%2C%20sharp%20graphic%20composition%2C%20subtle%20grain%2C%20no%20text&width=600&height=900&seq=poster-poxiao-zhiqian-2026&orientation=portrait",
  },
  {
    id: "haibian-de-jiushudian",
    title: "海边的旧书店",
    originalTitle: "海辺の古書店",
    year: 2023,
    releaseDate: "2023-03-10",
    genres: ["剧情", "治愈"],
    region: "日本",
    duration: 111,
    director: "荻上直",
    cast: ["小林聪", "松雪泰", "光石研"],
    rating: 8.5,
    views: 47230,
    tags: ["书店", "海边", "治愈"],
    quality: "高清",
    synopsis:
      "镰仓海边一间只在下雨天营业的旧书店，店主会给每位客人推荐一本「现在最需要」的书。一个失去方向的编辑推门进来，从此改变了两个人的生活节奏。",
    cover:
      "https://readdy.ai/api/search-image?query=Cozy%20Japanese%20healing%20drama%20poster%2C%20small%20seaside%20secondhand%20bookshop%20with%20open%20wooden%20doors%20and%20stacks%20of%20books%2C%20rain%20falling%20on%20a%20quiet%20street%2C%20warm%20lamp%20glow%2C%20cream%20and%20terracotta%20palette%2C%20soft%20film%20grain%2C%20no%20text%2C%20gentle%20editorial%20composition&width=600&height=900&seq=poster-haibian-de-jiushudian-2026&orientation=portrait",
  },
  {
    id: "chise-yuetai",
    title: "赤色月台",
    originalTitle: "赤いホーム",
    year: 2021,
    releaseDate: "2021-07-02",
    genres: ["犯罪", "剧情"],
    region: "日本",
    duration: 130,
    director: "绪方明",
    cast: ["永濑正", "宫崎葵", "大森南"],
    rating: 8.3,
    views: 59680,
    tags: ["车站", "罪与罚", "群像"],
    quality: "高清",
    synopsis:
      "一个深夜的终点站，五个陌生人在同一节车厢里目睹了一场冲突。警方介入后，五个人的口供却拼不出同一个真相。每个人都只说了对自己有利的那一部分。",
    cover:
      "https://readdy.ai/api/search-image?query=Japanese%20crime%20drama%20poster%2C%20empty%20red%20lit%20train%20platform%20at%20midnight%20with%20five%20separated%20figures%20waiting%2C%20strong%20crimson%20lighting%20against%20dark%20shadows%2C%20graphic%20geometric%20composition%2C%20fine%20film%20grain%2C%20no%20text%2C%20restrained%20editorial%20style&width=600&height=900&seq=poster-chise-yuetai-2026&orientation=portrait",
  },
  {
    id: "shanjian-xiaodiao",
    title: "山间小调",
    originalTitle: "山のうた",
    year: 2019,
    releaseDate: "2019-05-24",
    genres: ["家庭", "剧情"],
    region: "日本",
    duration: 113,
    director: "是枝裕",
    cast: ["树木希林", "井浦新", "尾野真"],
    rating: 8.7,
    views: 84320,
    tags: ["山村", "亲情", "四季"],
    quality: "高清",
    synopsis:
      "长野山村的一对老夫妇，在儿子一家搬回老家的一年里，重新学习如何相处。没有惊天动地的事件，只有饭桌上的沉默、田里的劳作，和一句迟到了很久的道歉。",
    cover:
      "https://readdy.ai/api/search-image?query=Gentle%20Japanese%20family%20drama%20poster%2C%20elderly%20couple%20sitting%20on%20a%20wooden%20engawa%20overlooking%20terraced%20mountain%20fields%20in%20late%20summer%2C%20warm%20green%20and%20cream%20palette%20with%20terracotta%20accents%2C%20soft%20natural%20light%2C%20film%20grain%2C%20no%20text&width=600&height=900&seq=poster-shanjian-xiaodiao-2026&orientation=portrait",
  },
  {
    id: "zuihou-de-wutai",
    title: "最后的舞台",
    originalTitle: "最後の舞台",
    year: 2024,
    releaseDate: "2024-03-15",
    genres: ["剧情", "音乐"],
    region: "日本",
    duration: 127,
    director: "三谷幸",
    cast: ["阿部贞", "深津绘", "役所广"],
    rating: 8.8,
    views: 95760,
    tags: ["舞台剧", "谢幕", "群像"],
    quality: "高清",
    synopsis:
      "一座即将拆除的老剧场，决定在拆除前上演最后一部戏。已经解散十年的剧团成员被一一找回，他们要面对的不只是一场演出，还有当年那场不欢而散的原因。",
    cover:
      "https://readdy.ai/api/search-image?query=Theatrical%20Japanese%20drama%20poster%2C%20empty%20old%20proscenium%20stage%20with%20a%20single%20spotlight%20and%20a%20lone%20chair%2C%20deep%20crimson%20velvet%20curtains%2C%20dust%20motes%20in%20the%20beam%2C%20warm%20amber%20and%20charcoal%20palette%2C%20elegant%20graphic%20composition%2C%20film%20grain%2C%20no%20text&width=600&height=900&seq=poster-zuihou-de-wutai-2026&orientation=portrait",
    backdrop:
      "https://readdy.ai/api/search-image?query=Wide%20cinematic%20view%20of%20a%20grand%20old%20Japanese%20theatre%20auditorium%2C%20empty%20red%20velvet%20seats%2C%20single%20spotlight%20on%20the%20stage%2C%20dust%20in%20the%20light%20beam%2C%20deep%20crimson%20and%20warm%20beige%20tones%2C%20atmospheric%20film%20grain%2C%20no%20text&width=1600&height=900&seq=backdrop-zuihou-de-wutai-2026&orientation=landscape",
  },
  {
    id: "beihai-de-shouhuren",
    title: "北海的守湖人",
    originalTitle: "北海の番人",
    year: 2022,
    releaseDate: "2022-08-05",
    genres: ["剧情", "悬疑"],
    region: "日本",
    duration: 136,
    director: "西川美",
    cast: ["妻夫木聪", "苍井优", "大竹忍"],
    rating: 8.1,
    views: 38940,
    tags: ["湖泊", "秘密", "自然"],
    quality: "高清",
    synopsis:
      "北海道一座封闭的火山口湖，守湖人二十年来记录着水位的每一次细微变化。当湖底打捞出一辆旧车，他终于不得不面对那个被自己沉进湖里的夏天。",
    cover:
      "https://readdy.ai/api/search-image?query=Brooding%20Japanese%20mystery%20drama%20poster%2C%20a%20still%20dark%20volcanic%20lake%20surrounded%20by%20misty%20pine%20forest%2C%20tiny%20wooden%20boathouse%20and%20a%20lone%20figure%20on%20a%20pier%2C%20desaturated%20gray%20green%20palette%20with%20crimson%20accent%2C%20heavy%20fog%2C%20film%20grain%2C%20no%20text&width=600&height=900&seq=poster-beihai-de-shouhuren-2026&orientation=portrait",
  },
  {
    id: "huayuan-de-zhongbiao",
    title: "花园的钟表",
    originalTitle: "庭の時計",
    year: 2020,
    releaseDate: "2020-06-19",
    genres: ["剧情", "文艺"],
    region: "日本",
    duration: 107,
    director: "岨手由",
    cast: ["门胁麦", "柄本佑", "石桥静"],
    rating: 7.8,
    views: 31260,
    tags: ["时间", "旧宅", "记忆"],
    quality: "高清",
    synopsis:
      "一位钟表修复师继承了祖母留下的老宅，院子里有一台停了二十年的落地钟。在修复它的过程中，他逐渐读懂了祖母留在齿轮间的那些细小痕迹。",
    cover:
      "https://readdy.ai/api/search-image?query=Refined%20Japanese%20art%20house%20film%20poster%2C%20antique%20grandfather%20clock%20standing%20in%20a%20sunlit%20garden%20of%20an%20old%20wooden%20house%2C%20warm%20dust%20in%20the%20light%2C%20muted%20cream%20and%20rust%20palette%2C%20soft%20focus%2C%20fine%20film%20grain%2C%20no%20text%2C%20calm%20composition&width=600&height=900&seq=poster-huayuan-de-zhongbiao-2026&orientation=portrait",
  },
  {
    id: "yueguang-xia-de-jietou",
    title: "月光下的街头",
    originalTitle: "月光の街",
    year: 2023,
    releaseDate: "2023-09-29",
    genres: ["剧情", "青春"],
    region: "日本",
    duration: 115,
    director: "李相日",
    cast: ["菅田将晖", "仲野太", "古川琴"],
    rating: 8.0,
    views: 51470,
    tags: ["夜晚", "青春", "群像"],
    quality: "高清",
    synopsis:
      "大阪的深夜街头，四个在便利店、居酒屋和livehouse之间辗转的年轻人，用一整个夏天寻找各自的出口。月光照不到的地方，他们自己点亮了灯。",
    cover:
      "https://readdy.ai/api/search-image?query=Neon%20lit%20Japanese%20youth%20drama%20poster%2C%20four%20young%20people%20walking%20across%20a%20quiet%20Osaka%20street%20at%20midnight%2C%20warm%20shop%20signs%20and%20moonlight%2C%20muted%20crimson%20and%20amber%20palette%2C%20soft%20bokeh%2C%20film%20grain%2C%20no%20text%2C%20cinematic%20vertical%20composition&width=600&height=900&seq=poster-yueguang-xia-de-jietou-2026&orientation=portrait",
  },
  {
    id: "chunri-de-ni",
    title: "春日的你",
    originalTitle: "春のきみ",
    year: 2024,
    releaseDate: "2024-04-19",
    genres: ["爱情", "青春"],
    region: "日本",
    duration: 109,
    director: "今泉力",
    cast: ["福原遥", "板垣李", "上白石萌"],
    rating: 8.0,
    views: 63290,
    tags: ["校园", "春天", "初恋"],
    quality: "高清",
    synopsis:
      "转学生在一所海边高中的樱花树下，遇见了那个每年春天都会在同一位置等一个人的女孩。一个关于时间差与勇气的初恋故事。",
    cover:
      "https://readdy.ai/api/search-image?query=Bright%20Japanese%20youth%20romance%20poster%2C%20two%20high%20school%20students%20under%20a%20large%20blooming%20cherry%20tree%20beside%20a%20seaside%20school%20gate%2C%20pale%20pink%20and%20warm%20cream%20palette%2C%20sunlight%20through%20petals%2C%20soft%20film%20grain%2C%20no%20text%2C%20airy%20romantic%20composition&width=600&height=900&seq=poster-chunri-de-ni-2026&orientation=portrait",
    backdrop:
      "https://readdy.ai/api/search-image?query=Wide%20cinematic%20spring%20scene%20in%20Japan%2C%20blooming%20cherry%20blossom%20branches%20framing%20a%20seaside%20school%20path%2C%20soft%20pink%20petals%20drifting%20in%20warm%20afternoon%20light%2C%20gentle%20cream%20and%20rose%20tones%2C%20dreamy%20shallow%20depth%20of%20field%2C%20film%20grain%2C%20no%20text&width=1600&height=900&seq=backdrop-chunri-de-ni-2026&orientation=landscape",
  },
  {
    id: "yongye-de-bianjibu",
    title: "永夜的编辑部",
    originalTitle: "永夜の編集部",
    year: 2021,
    releaseDate: "2021-01-22",
    genres: ["悬疑", "剧情"],
    region: "日本",
    duration: 122,
    director: "吉田大",
    cast: ["松山研一", "宫藤官", "池胁千"],
    rating: 8.2,
    views: 45980,
    tags: ["媒体", "真相", "密室"],
    quality: "高清",
    synopsis:
      "一家即将停刊的周刊编辑部，在截稿前收到了匿名寄来的一份旧档案。为了确认它的真伪，仅剩的三名编辑在通宵的办公室里，翻开了这座城市最不愿被提起的一页。",
    cover:
      "https://readdy.ai/api/search-image?query=Moody%20Japanese%20newsroom%20thriller%20poster%2C%20cluttered%20late%20night%20editorial%20office%20with%20stacked%20papers%20and%20green%20desk%20lamps%2C%20single%20figure%20reading%20a%20file%2C%20deep%20crimson%20and%20warm%20gray%20palette%2C%20harsh%20window%20light%2C%20film%20grain%2C%20no%20text&width=600&height=900&seq=poster-yongye-de-bianjibu-2026&orientation=portrait",
  },
  {
    id: "lutu-de-zhongdian",
    title: "旅途的终点",
    originalTitle: "旅の終わり",
    year: 2018,
    releaseDate: "2018-10-05",
    genres: ["剧情", "公路"],
    region: "日本",
    duration: 131,
    director: "市川昆",
    cast: ["高仓健", "倍赏千惠子", "田中邦"],
    rating: 8.6,
    views: 77310,
    tags: ["旅途", "经典", "北海道"],
    quality: "4K 修复",
    synopsis:
      "一名退休的铁路司机在最后一次值乘结束后，独自踏上了年轻时没能走完的那条路线。从函馆到稚内，他一路寻找的不是风景，而是当年在站台上转身离开的那个人。",
    cover:
      "https://readdy.ai/api/search-image?query=Classic%20Japanese%20road%20movie%20poster%20in%20restored%20film%20style%2C%20lone%20older%20man%20in%20a%20coat%20standing%20at%20a%20remote%20Hokkaido%20railway%20station%2C%20snowy%20fields%20and%20pale%20sunset%2C%20muted%20ochre%20and%20gray%20palette%2C%20visible%20analog%20grain%2C%20no%20text%2C%20melancholic%20editorial%20composition&width=600&height=900&seq=poster-lutu-de-zhongdian-2026&orientation=portrait",
  },
];

export const featuredIds = ["yekou-lieche", "zuihou-de-wutai", "chunri-de-ni", "dongjing-canxiang"];

export const genreOptions = [
  "剧情",
  "爱情",
  "悬疑",
  "动作",
  "犯罪",
  "经典",
  "家庭",
  "青春",
  "历史",
  "文艺",
  "治愈",
  "公路",
  "音乐",
  "惊悚",
];

export const yearOptions = ["2024", "2023", "2022", "2021", "2020", "更早"];

export const regionOptions = ["日本", "日台合拍", "日韩合拍"];

export const sortOptions = [
  { value: "latest", label: "最新发布" },
  { value: "views", label: "热度最高" },
  { value: "rating", label: "评分最高" },
] as const;